import CONSTANTS from "@/common/constants";

const dashboardRoutes = [
  {
    path: "/",
    name: "DASHBOARD_MAIN",
    component: () => import("@/views/Dashboard/Dashboard.vue"),
    meta: {
      auth: CONSTANTS.ROUTE.CODE.DASHBOARD,
      layout: "FULL",
    },
    children: [
      {
        path: "summary",
        name: "DASHBOARD_SUMMARY",
        component: () =>
          import("@/views/Dashboard/DashboardSummary/Summary.vue"),
        meta: {
          auth: CONSTANTS.ROUTE.CODE.DASHBOARD,
          layout: "FULL",
        },
      },
      {
        path: "test",
        name: "DASHBOARD_TEST",
        component: () => import("@/views/Dashboard/DashboardTest/Test.vue"),
        meta: {
          auth: CONSTANTS.ROUTE.CODE.DASHBOARD,
          layout: "FULL",
        },
      },
      {
        path: "status",
        name: "DASHBOARD_STATUS",
        component: () => import("@/views/Dashboard/DashboardStatus/Status.vue"),
        meta: {
          auth: CONSTANTS.ROUTE.CODE.DASHBOARD,
          layout: "FULL",
        },
      },
      {
        path: "member",
        name: "DASHBOARD_MEMBER",
        component: () => import("@/views/Dashboard/DashboardMember/Member.vue"),
        meta: {
          auth: CONSTANTS.ROUTE.CODE.DASHBOARD,
          layout: "FULL",
        },
      },
      {
        path: "result",
        name: "DASHBOARD_RESULT",
        component: () => import("@/views/Dashboard/DashboardResult/Result.vue"),
        meta: {
          auth: CONSTANTS.ROUTE.CODE.DASHBOARD,
          layout: "FULL",
        },
      },
      {
        path: "dataset",
        name: "DASHBOARD_DATASET",
        component: () =>
          import("@/views/Dashboard/DashboardDataset/Dataset.vue"),
        meta: {
          auth: CONSTANTS.ROUTE.CODE.DASHBOARD,
          layout: "FULL",
        },
      },
    ],
  },
];

export default dashboardRoutes;
